import PropTypes from 'prop-types';

export class Address { }

Address.propTypes = PropTypes.shape({
  AddressLine1: PropTypes.string.isRequired,
  AddressLine2: PropTypes.string,
  AddressType: PropTypes.number.isRequired,
  City: PropTypes.string.isRequired,
  CountryCode: PropTypes.string.isRequired,
  CountryName: PropTypes.string.isRequired,
  Id: PropTypes.string.isRequired,
  Name: PropTypes.string.isRequired,
  Phone: PropTypes.string,
  PostalCode : PropTypes.string.isRequired,
  State : PropTypes.string.isRequired
})




// WEBPACK FOOTER //
// ./src/Components/checkout/models/Address.js